<template>
  <div class="main-container">
    <div class="btn-wrap">
      <Button type="primary" ghost @click="back($route.query.backUrl)">返回</Button>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <div class="statistics">
        <span>代理人：{{ detail.owerName }}</span>
        <span>当前职级：{{ IFA_RANK[detail.ifaLevel] }}</span>
        <span>入职日期：{{ detail.entryTime | filterTime('YYYY-MM-DD') }}</span>
        <span>结算日期：{{ detail.settlementDate | filterTime('YYYY-MM-DD') }}</span>
        <span>是否团队长：{{ detail.isLeader == 1 ? '是' : '否' }}</span>
        <span>
          <Poptip transfer :max-width="100" trigger="hover" content="上一季度是否active状态">
            是否active状态<Icon type="md-help-circle" size="18" />：{{ detail.activeStatus == 1 ? '是' : '否' }}</Poptip
          >
        </span>
        <span>佣金合计（港币）：{{ totalCommission }}</span>
        <span class="check-status"
          >对账状态:
          <Tag v-if="detail.checkStatus == 1" color="orange">待确认</Tag>
          <Tag v-if="detail.checkStatus == 2" color="orange">已确认待打款</Tag>
          <Tag v-if="detail.checkStatus == 3" color="green">打款成功</Tag>
        </span>
      </div>
      <template v-if="settlementLogList.length > 0">
        <div class="title">收益项明细</div>
        <vxe-table :show-footer="false" border min-height="0" align="center" max-height="300" :data="settlementLogList">
          <vxe-column field="index" title="序号" width="100">
            <template #default="{ rowIndex }">
              <span>{{ rowIndex + 1 }}</span>
            </template>
          </vxe-column>
          <vxe-column field="commissionCategory" title="类型" min-width="140">
            <template #default="{ row }">
              <span>{{ row.commissionCategory == 1 ? '周边收支与佣金调整' : '基本法' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="commissionType" title="收益项" min-width="100">
            <template #default="{ row }">
              <span>{{ row.commissionCategory == 1 ? extraCommissionTypeMap[row.commissionType] : commissionTypeMap[row.commissionType] }}</span>
            </template>
          </vxe-column>
          <vxe-column field="settleCommissionPrice" title="结算佣金(港币)" min-width="130"></vxe-column>
          <vxe-column field="remark" title="备注" min-width="130">
            <template #default="{ row }">
              <span>{{ row.remark || '-' }}</span>
            </template>
          </vxe-column>
        </vxe-table>
      </template>
      <template v-if="salesCommissionLogList.length > 0">
        <div class="title" style="margin-top: 20px">销售佣金</div>
        <vxe-table border align="center" min-height="0" max-height="600" :data="salesCommissionLogList">
          <vxe-column field="policyNo" title="保单编号" center width="160" fixed="left">
            <template #default="{ row }">
              <div><Icon v-if="row.isReferral == 1" type="md-star" style="margin-right: 4px;" /> {{row.policyNo}}</div>
            </template>
          </vxe-column>
          <vxe-column field="commission" title="佣金率(%)" min-width="130"></vxe-column>
          <vxe-column field="settleRate" title="结算汇率" min-width="130"></vxe-column>
          <vxe-column field="settleCommissionPrice" title="结算佣金(港币)" min-width="130"></vxe-column>
          <vxe-column field="policyStatus" title="保单状态" center min-width="130">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.policyStatus" dicType="POLICY_STATUS"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="commissionIndex" title="保单期数" min-width="100"></vxe-column>
          <vxe-column field="suppliers" title="供应商" min-width="130">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.suppliers" dicType="SUPPLIERS"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="companyName" title="保险公司" min-width="130"></vxe-column>
          <vxe-column field="productName" title="产品名称" min-width="150"></vxe-column>
          <vxe-column field="productType" title="产品类型" min-width="130">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.productType" dicType="PRODUCT_TYPE2"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="signDate" title="签单日期" min-width="130">
            <template #default="{ row }">
              {{ row.signDate | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="effectDate" title="生效日期" min-width="130">
            <template #default="{ row }">
              {{ row.effectDate | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="expirationDate" title="冷静期截止日" min-width="130">
            <template #default="{ row }">
              {{ row.expirationDate | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="paymentPeriod" title="年缴保费" min-width="180">
            <template #default="{ row }">
              {{ row.fee }} <lzDicTxt :dicCode="row.currencyType" dicType="CURRENCY_TYPE"></lzDicTxt>/{{ row.paymentPeriod }}<lzDicTxt v-if="row.paymentType" :dicCode="row.paymentType" dicType="GUARANTEE_TYPE"></lzDicTxt><span v-else>年</span>
            </template>
          </vxe-column>
          <vxe-column field="agentName" title="签单代理人" min-width="180">
            <template #header="{}">
              <Poptip trigger="hover" content="content" transfer>
                <span>签单代理人</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <p>职级为签单时的职级</p>
                </div>
              </Poptip>
            </template>
            <template #default="{ row }"> {{ row.agentStaffNo }}/{{ row.agentName }} </template>
          </vxe-column>
        </vxe-table>
      </template>
      <template v-if="recommendBonusLogList.length > 0">
        <div class="title" style="margin-top: 20px">推荐奖</div>
        <vxe-table border align="center" min-height="0" max-height="600" :data="recommendBonusLogList">
          <vxe-column field="agentName" title="被推荐人" min-width="130"></vxe-column>
          <vxe-column field="staffNo" title="工号" min-width="130"></vxe-column>
          <vxe-column field="ifaLevel" title="当前职级" width="100">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.ifaLevel" dicType="IFA_RANK"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="entryTime" title="入职日期" width="100">
            <template #default="{ row }">
              {{ row.entryTime | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="groupName" title="所属团队" min-width="130"></vxe-column>
          <vxe-column field="awardAmount" title="推荐奖(港币)" min-width="130"></vxe-column>
          <vxe-column field="action1" title="操作" width="100" fixed="right">
            <template #default="{ row }">
              <span class="table-btn" @click="openDetail(row, 1)">明细</span>
            </template>
          </vxe-column>
        </vxe-table>
      </template>
      <template v-if="tutorBonusLogList.length > 0">
        <div class="title" style="margin-top: 20px">辅导奖</div>
        <vxe-table border align="center" min-height="0" max-height="600" :data="tutorBonusLogList">
          <vxe-column field="agentName" title="被辅导人" min-width="130"></vxe-column>
          <vxe-column field="staffNo" title="工号" min-width="130"></vxe-column>
          <vxe-column field="ifaLevel" title="当前职级" width="100">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.ifaLevel" dicType="IFA_RANK"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="entryTime" title="入职日期" width="100">
            <template #default="{ row }">
              {{ row.entryTime | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="groupName" title="所属团队" min-width="130"></vxe-column>
          <vxe-column field="awardAmount" title="辅导奖(港币)" min-width="130"></vxe-column>
          <vxe-column field="action1" title="操作" width="100" fixed="right">
            <template #default="{ row }">
              <span class="table-btn" @click="openDetail(row, 2)">明细</span>
            </template>
          </vxe-column>
        </vxe-table>
      </template>
      <template v-if="surroundAdjustLogList && surroundAdjustLogList.length > 0">
        <div class="title" style="margin-top: 20px">周边收支和佣金调整</div>
        <vxe-table border align="center" min-height="0" max-height="600" :data="surroundAdjustLogList">
          <vxe-column field="owerName" title="IFA" min-width="120"></vxe-column>
          <vxe-column field="owerLevel" title="职级" min-width="100">
            <template #default="{ row }">
              <span>{{ ifaLevelMap[row.owerLevel] || '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="policyNo" title="保单编号" min-width="120"></vxe-column>
          <vxe-column field="commissionType" title="佣金项类型" min-width="120">
            <template #default="{ row }">
              <span>{{ extraCommissionTypeMap[row.commissionType] || '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="settleCommissionPrice" title="积分（港币）" min-width="130"></vxe-column>
          <vxe-column field="incomeType" title="收支类型" min-width="100">
            <template #default="{ row }">
              <span v-if="row.incomeType == 1">收入</span>
              <span v-else-if="row.incomeType == 2">支出</span>
              <span v-else>-</span>
            </template>
          </vxe-column>
          <vxe-column field="remark" title="备注" min-width="150">
            <template #default="{ row }">
              <span>{{ row.remark || '-' }}</span>
            </template>
          </vxe-column>
        </vxe-table>
      </template>
      <template v-if="teamBonusLogList.length > 0">
        <div class="title" style="margin-top: 20px">管理津贴</div>
        <vxe-table border align="center" min-height="0" max-height="600" :data="teamBonusLogList">
          <vxe-column field="agentName" title="团员" min-width="130"></vxe-column>
          <vxe-column field="staffNo" title="工号" min-width="130"></vxe-column>
          <vxe-column field="ifaLevel" title="当前职级" width="100">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.ifaLevel" dicType="IFA_RANK"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="entryTime" title="入职日期" width="100">
            <template #default="{ row }">
              {{ row.entryTime | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="groupName" title="所属团队" min-width="130"></vxe-column>
          <vxe-column field="awardAmount" title="管理津贴(港币)" min-width="130"></vxe-column>
          <vxe-column field="action1" title="操作" width="100" fixed="right">
            <template #default="{ row }">
              <span class="table-btn" @click="openDetail(row, 3)">明细</span>
            </template>
          </vxe-column>
        </vxe-table>
      </template>
      <template v-if="trainBonusLogList && trainBonusLogList.length > 0">
        <div class="title" style="margin-top: 20px">育成奖励</div>
        <vxe-table border align="center" min-height="0" max-height="600" :data="trainBonusLogList">
          <vxe-column field="leaderName" title="被直接育成人" min-width="130"></vxe-column>
          <vxe-column field="staffNo" title="工号" min-width="130"></vxe-column>
          <vxe-column field="ifaLevel" title="当前职级" width="100">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.ifaLevel" dicType="IFA_RANK"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="trainerEffectDate" title="被育成时间" width="100">
            <template #default="{ row }">
              {{ row.trainerEffectDate | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="teamContributionCount" title="团队贡献奖励人数" min-width="130"></vxe-column>
          <vxe-column field="groupName" title="所属团队" min-width="130"></vxe-column>
          <vxe-column field="awardAmount" title="育成奖(港币)" min-width="130"></vxe-column>
          <vxe-column field="action1" title="操作" width="100" fixed="right">
            <template #default="{ row }">
              <span class="table-btn" @click="openDetail(row, 4)">明细</span>
            </template>
          </vxe-column>
        </vxe-table>
      </template>
      <template v-if="personalBonusLogList && personalBonusLogList.length > 0">
        <div class="title" style="margin-top: 20px">年度个人Bonus</div>
        <vxe-table border align="center" min-height="0" max-height="600" :data="personalBonusLogList">
          <vxe-column field="policyNo" title="保单编号" width="100" fixed="left"> </vxe-column>
          <vxe-column field="policyStatus" title="保单状态" min-width="130">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.policyStatus" dicType="POLICY_STATUS"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="commissionIndex" title="保单期数" min-width="100"></vxe-column>
          <vxe-column field="suppliers" title="供应商" min-width="130">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.suppliers" dicType="SUPPLIERS"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="companyName" title="保险公司" min-width="130"></vxe-column>
          <vxe-column field="productName" title="产品名称" min-width="130"></vxe-column>
          <vxe-column field="productType" title="产品类型" min-width="130">
            <template #default="{ row }">
              <lzDicTxt :dicCode="row.productType" dicType="PRODUCT_TYPE2"></lzDicTxt>
            </template>
          </vxe-column>
          <vxe-column field="signDate" title="签单日期" min-width="130">
            <template #default="{ row }">
              {{ row.signDate | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="effectDate" title="生效日期" min-width="130">
            <template #default="{ row }">
              {{ row.effectDate | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="expirationDate" title="冷静期截止日" min-width="130">
            <template #default="{ row }">
              {{ row.expirationDate | filterTime('YYYY-MM-DD') }}
            </template>
          </vxe-column>
          <vxe-column field="paymentPeriod" title="年缴保费" min-width="180">
            <template #default="{ row }">
              {{ row.fee }} <lzDicTxt :dicCode="row.currencyType" dicType="CURRENCY_TYPE"></lzDicTxt>/{{ row.paymentPeriod }}<lzDicTxt v-if="row.paymentType" :dicCode="row.paymentType" dicType="GUARANTEE_TYPE"></lzDicTxt><span v-else>年</span>
            </template>
          </vxe-column>
          <vxe-column field="agentName" title="签单代理人" min-width="180">
            <template #header="{}">
              <Poptip trigger="hover" content="content" transfer>
                <span>签单代理人</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <p>职级为签单时的职级</p>
                </div>
              </Poptip>
            </template>
            <template #default="{ row }"> {{ row.agentStaffNo }}/{{ row.agentName }} </template>
          </vxe-column>
          <vxe-column field="commission" title="佣金率(%)" min-width="130"></vxe-column>
          <vxe-column field="settleRate" title="结算汇率" min-width="130"></vxe-column>
          <vxe-column field="settleCommissionPrice" title="结算佣金(港币)" min-width="130"></vxe-column>
        </vxe-table>
      </template>
    </div>
    <detailModalRef ref="detailModalRef"></detailModalRef>
  </div>
</template>
        
        <script>
import { common, pageTool } from '@/api/mixins';
import lzDicTxt from '@/components/commons/lzDicTxt';

import detailModalRef from './components/detailModalRef.vue';

export default {
  mixins: [common, pageTool],
  components: {
    lzDicTxt,
    detailModalRef
  },

  data() {
    const dic = JSON.parse(localStorage.dic);
    return {
      id: '',
      commissionTypeMap: {
        1: '基础销售佣金',
        11: '个人Bonus',
        12: '管理津贴',
        13: '推荐奖',
        14: '辅导奖',
        15: '育成奖',
        16: '育成奖'
      },
      extraCommissionTypeMap: {
        1: '周边收支',
        2: '佣金调整'
      },
      ifaLevelMap: {
        0: '',
        1: '萌新',
        2: '新贵',
        3: '精英',
        4: '王者'
      },
      IFA_RANK: dic.IFA_RANK,
      owerId: '',
      settleId: '',
      visible: false,
      loading: false,
      detail: {},
      settlementLogList: [],
      salesCommissionLogList: [],
      personalBonusLogList: [],
      teamBonusLogList: [],
      recommendBonusLogList: [],
      tutorBonusLogList: [],
      trainBonusLogList: [],
      surroundAdjustLogList: [],
      totalCommission:''
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.owerId = this.$route.query.owerId;
    this.settleId = this.$route.query.settleId;
    this.totalCommission = this.$route.query.totalCommission;
    this.getDetail();
  },
  methods: {
    openDetail(row, type) {
      let params = {
        settleId: this.settleId,
        commissionTypeList: [],
        owerId: this.owerId
      };
      // 1基础销售佣金 11个人Bonus 12管理津贴 13推荐奖 14辅导奖 15/16育成奖
      if (type == 1) {
        params.agentId = row.agentId;
        params.commissionTypeList = [13];
      } else if (type == 2) {
        params.agentId = row.agentId;
        params.commissionTypeList = [14];
      } else if (type == 3) {
        params.commissionTypeList = [12];
        params.agentId = row.agentId;
      } else if (type == 4) {
        params.commissionTypeList = [15, 16];
        params.leaderId = row.leaderId;
      }
      this.$refs.detailModalRef.open(params);
    },
    getDetail() {
      this.$http({
        url: '/buz/ifaSettlementReport/queryCheckDetail',
        type: 'GET',
        data: {
          id: this.id
        }
      })
        .then(res => {
          this.detail = res.data;
          this.$nextTick(() => {
            this.salesCommissionLogList = res.data.salesCommissionLogList || [];
            this.settlementLogList = [
              ...(res.data.settlementLogList || []).map(item => ({ ...item, commissionCategory: 0 })),
              ...(res.data.extraSettlementLogList || []).map(item => ({ ...item, commissionCategory: 1 }))
            ];
            this.personalBonusLogList = res.data.personalBonusLogList || [];
            this.teamBonusLogList = res.data.teamBonusLogList || [];
            this.recommendBonusLogList = res.data.recommendBonusLogList || [];
            this.tutorBonusLogList = res.data.tutorBonusLogList || [];
            this.trainBonusLogList = res.data.trainBonusLogList || [];
            this.surroundAdjustLogList = res.data.surroundAdjustLogList || [];
          });
        })
        .finally(() => {
          this.$notice.hideLoading();
        });
    }
  }
};
</script>
    <style lang="scss" scoped>
.main-container {
  .check-status {
    position: fixed;
    top: 20px;
    right: 120px;
  }
  /deep/ .tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #ccc;
    color: #ccc;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .btn-wrap {
    text-align: right;
  }
  /deep/.ivu-table-header {
    overflow: hidden;
  }
  .ivu-table-wrapper {
    overflow: hidden;
  }
  .table-box .ivu-table {
    overflow-x: hidden;
  }

  .title {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 10px;
  }
  .statistics {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    margin-right: 250px;
    span {
      flex: 0 0 300px;
      margin-bottom: 10px;
    }
  }
}
</style>
        